import type { TourStep } from '../types';

export const sketchToolSteps: TourStep[] = [
  {
    target: '[data-tour="tool-sketch"]',
    title: 'Floor Plan Sketch Tool',
    content:
      'This tool lets you draw professional floor plans with room labels, dimensions, and area calculations. Let\'s open it up.',
    placement: 'bottom',
    route: '/appraisals/tools',
    nextButtonText: 'Open it',
  },
  {
    target: '[data-tour="sketch-header"]',
    title: 'Sketch Playground',
    content:
      'Welcome to the standalone sketch workspace. This isn\'t linked to any report — perfect for practice or quick sketches. Your work saves automatically to your browser.',
    placement: 'bottom',
    route: '/appraisals/tools/sketch',
  },
  {
    target: '[data-tour="sketch-drawing-tools"]',
    title: 'Drawing Tools',
    content:
      'These are your main tools. Try selecting Quick Shape Wizard (the grid icon) to quickly add a rectangular room, or Draw Perimeter (pencil) to trace walls freehand. Each tool has a keyboard shortcut shown in its tooltip.',
    placement: 'bottom',
    route: '/appraisals/tools/sketch',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve picked a tool',
  },
  {
    target: '[data-tour="sketch-canvas"]',
    title: 'Draw a Room',
    content:
      'Click and drag on the canvas to draw. Try creating a simple room shape — you can resize and reposition it after. Use the Select tool (V) to move shapes around.',
    placement: 'top',
    route: '/appraisals/tools/sketch',
    isActionStep: true,
    spotlightClicks: true,
    spotlightPadding: 0,
    nextButtonText: 'I\'ve drawn something',
  },
  {
    target: '[data-tour="sketch-grid-settings"]',
    title: 'Grid & Precision Settings',
    content:
      'Toggle the grid (G) and snap-to-grid (S) for precise alignment. Turn on Edge Dimensions (ruler icon) to see measurements on each wall. ANSI Z765 mode follows the standard for residential GLA measurement.',
    placement: 'bottom',
    route: '/appraisals/tools/sketch',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="sketch-export-tools"]',
    title: 'Export Your Work',
    content:
      'When you\'re happy with your sketch, use the download button to export as a vector PDF or WebP images. You can also toggle perimeter dimension labels for the export.',
    placement: 'bottom',
    route: '/appraisals/tools/sketch',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
];
